module.exports = __webpack_public_path__ + "static/kapsulki_rozpuszczalna-5d12b953ddd9d2e413b0d817aad25dcb.png";